export type FieldComponentLoader = () => Promise<any>;

export const MPS_COMPONENTS_REGISTRY: Record<string, FieldComponentLoader> = {
  MpsFallbackComponent: () =>
    import('@mps/mps-kit/mps-component-loader/components/mps-fallback.component').then((m) => m.MpsFallbackComponent),

  'frame.email': () =>
    import('@mps/mps-kit/mps-frame/components/fields/mps-frame-email.component').then((m) => m.MpsFrameEmailComponent),

  //Table renderer components
  MpsTableGridComponent: () =>
    import('@mps/mps-kit/mps-table/components/renderer/grid/mps-table-grid.component').then(
      (m) => m.MpsTableGridComponent
    ),
  MpsTableCardComponent: () =>
    import('@mps/mps-kit/mps-table/components/renderer/card/mps-table-card.component').then(
      (m) => m.MpsTableCardComponent
    ),
  MpsTableListComponent: () =>
    import('@mps/mps-kit/mps-table/components/renderer/list/mps-table-list.component').then(
      (m) => m.MpsTableListComponent
    ),

  //Frame renderer components
  MpsFrameEmailRendererComponent: () =>
    import('@mps/mps-kit/mps-frame/components/renderers/mps-frame-email-renderer.component').then(
      (m) => m.MpsFrameEmailRendererComponent
    ),
};
